import { render } from "./MotivosAnulacion.vue?vue&type=template&id=be9384da&scoped=true"
import script from "./MotivosAnulacion.vue?vue&type=script&lang=js"
export * from "./MotivosAnulacion.vue?vue&type=script&lang=js"

import "./MotivosAnulacion.vue?vue&type=style&index=0&id=be9384da&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9384da"]])

export default __exports__